module.exports = __webpack_public_path__ + "img/login-backspace.736d3c6c.svg";